<template>
  <single-membership-table memTypeCode="MEM" memStatusCode="STU" />
</template>

<script>
import SingleMembershipTable from "@/components/SingleMembershipTable";
export default {
  components: {
    SingleMembershipTable,
  },
};
</script>

<style lang="scss" scoped></style>
